export enum PriceCompareMemberPageStatus {
  /**
   * 待发布
   */
  WAIT_PUBLISH = 0,

  /**
   * 待审核
   */
  WAIT_AUDIT = 1,

  /**
   * 审核不通过
   */
  AUDIT_FAIL = 2,

  /**
   * 待开始
   */
  WAIT_START = 3,

  /**
   * 报价中
   */
  BIDDING = 4,

  /**
   * 待委托方确认
   */
  WAIT_ENTRUST_CONFIRM = 5,

  /**
   * 待委托方再次确认
   */
  WAIT_ENTRUST_CONFIRM_AGAIN = 6,

  /**
   * 待参与方确认
   */
  WAIT_PARTICIPANT_CONFIRM = 7,

  /**
   * 委托方已确认
   */
  ENTRUST_CONFIRMED = 8,

  /**
   * 已成交
   */
  DEAL_ALL = 9,

  /**
   * 部分成交
   */
  DEAL_PART = 10,

  /**
   * 未成交
   */
  DEAL_FAIL = 11,

  /**
   * 委托方终止交易
   */
  ENTRUST_HALT = 12,

  /**
   * 终止未通过
   */
  HALT_FAIL = 13,

  /**
   * 已终止
   */
  HALT_SUCCESS = 14
}

/**
 * 委托方看到的状态文本
 */
export const PriceCompareMemberPageStatusEntrustTextMap = {
  [PriceCompareMemberPageStatus.WAIT_PUBLISH]: '待发布',
  [PriceCompareMemberPageStatus.WAIT_AUDIT]: '待审核',
  [PriceCompareMemberPageStatus.AUDIT_FAIL]: '审核不通过',
  [PriceCompareMemberPageStatus.WAIT_START]: '待开始',
  [PriceCompareMemberPageStatus.BIDDING]: '报价中',
  [PriceCompareMemberPageStatus.WAIT_ENTRUST_CONFIRM]: '待确认',
  [PriceCompareMemberPageStatus.WAIT_ENTRUST_CONFIRM_AGAIN]: '待再次确认',
  [PriceCompareMemberPageStatus.WAIT_PARTICIPANT_CONFIRM]: '待参与方确认',
  [PriceCompareMemberPageStatus.ENTRUST_CONFIRMED]: '已确认',
  [PriceCompareMemberPageStatus.DEAL_ALL]: '已成交',
  [PriceCompareMemberPageStatus.DEAL_PART]: '部分成交',
  [PriceCompareMemberPageStatus.DEAL_FAIL]: '未成交',
  [PriceCompareMemberPageStatus.ENTRUST_HALT]: '交易终止中',
  [PriceCompareMemberPageStatus.HALT_FAIL]: '终止未通过',
  [PriceCompareMemberPageStatus.HALT_SUCCESS]: '已终止'
}

/**
 * 参与方看到的状态文本
 */
export const PriceCompareMemberPageStatusParticipantTextMap = {
  [PriceCompareMemberPageStatus.WAIT_PUBLISH]: '待发布',
  [PriceCompareMemberPageStatus.WAIT_AUDIT]: '待审核',
  [PriceCompareMemberPageStatus.AUDIT_FAIL]: '审核不通过',
  [PriceCompareMemberPageStatus.WAIT_START]: '待开始',
  [PriceCompareMemberPageStatus.BIDDING]: '报价中',
  [PriceCompareMemberPageStatus.WAIT_ENTRUST_CONFIRM]: '待委托方确认',
  [PriceCompareMemberPageStatus.WAIT_ENTRUST_CONFIRM_AGAIN]: '待委托方再次确认',
  [PriceCompareMemberPageStatus.WAIT_PARTICIPANT_CONFIRM]: '待确认',
  [PriceCompareMemberPageStatus.ENTRUST_CONFIRMED]: '委托方已确认',
  [PriceCompareMemberPageStatus.DEAL_ALL]: '已成交',
  [PriceCompareMemberPageStatus.DEAL_PART]: '部分成交',
  [PriceCompareMemberPageStatus.DEAL_FAIL]: '未成交',
  [PriceCompareMemberPageStatus.ENTRUST_HALT]: '交易终止中',
  [PriceCompareMemberPageStatus.HALT_FAIL]: '终止未通过',
  [PriceCompareMemberPageStatus.HALT_SUCCESS]: '已终止'
}

export const PriceCompareMemberPageStatusColorMap = {
  [PriceCompareMemberPageStatus.WAIT_PUBLISH]: 'default',
  [PriceCompareMemberPageStatus.WAIT_AUDIT]: 'default',
  [PriceCompareMemberPageStatus.AUDIT_FAIL]: 'default',
  [PriceCompareMemberPageStatus.WAIT_START]: 'default',
  [PriceCompareMemberPageStatus.BIDDING]: 'processing',
  [PriceCompareMemberPageStatus.WAIT_ENTRUST_CONFIRM]: 'processing',
  [PriceCompareMemberPageStatus.WAIT_ENTRUST_CONFIRM_AGAIN]: 'processing',
  [PriceCompareMemberPageStatus.WAIT_PARTICIPANT_CONFIRM]: 'processing',
  [PriceCompareMemberPageStatus.ENTRUST_CONFIRMED]: 'processing',
  [PriceCompareMemberPageStatus.DEAL_ALL]: 'success',
  [PriceCompareMemberPageStatus.DEAL_PART]: 'success',
  [PriceCompareMemberPageStatus.DEAL_FAIL]: 'default',
  [PriceCompareMemberPageStatus.ENTRUST_HALT]: 'warning',
  [PriceCompareMemberPageStatus.HALT_FAIL]: 'warning',
  [PriceCompareMemberPageStatus.HALT_SUCCESS]: 'default'
}
